import {AfterContentInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {Observable, Subscription}                          from 'rxjs';
import {ApDynComponentComponent}                           from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                          from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                          from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynGridPropertyColumnConfig
}                                                          from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                                          from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardSection
}                                                          from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApDynGridStatusColumnConfig
}                                                          from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {first}                                             from 'lodash';
import {ImportStore}                                       from '../../stores/import/import.store';
import {MapViewStore}                                      from '../../stores/layout/mapview.store';
import {TranslationStore}                                  from '../../stores/translation/translation.store';
import IDataSetColumn = Data.Import.IDataSetColumn;
import IDataSetType = Data.Import.IDataSetType;

/**
 * Component for the upload formats
 */
@Component({
  selector: 'ap-upload-formats',
  template: `
    <ap-dyncomponent [caption]="'Global__Overview_Data_Types'"
                     [canSearch]="true"
                     [headerIcon]="'ap-file-icon'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns"
                     [items]="items"
                     [loading$]="importDataSetLoading$"
                     [pager]="pager"
                     [groupable]="true"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
    ></ap-dyncomponent>`
})
export class ApUploadFormatsComponent implements AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  columns: ApDynGridColumnConfigBase[] = [];
  items: any[] = [];
  pager: ApDynGridPagerConfigBase;
  importDataSetLoading$: Observable<boolean>;

  private _subscriptions: Array<Subscription> = [];
  private _dataSetColumns: IDataSetColumn[] = [];

  constructor(private store: ImportStore,
              private translationStore: TranslationStore,
              private mapViewStore: MapViewStore) {
    this.mapViewStore.hideMapView();
  }

  ngAfterContentInit(): void {
    this.store.loadImportDataSetColumns();
    this.getDataFromStore();
    this.gridBuilder();
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(d => {
      d.unsubscribe();
    });
  }

  getDataFromStore(): void {
    this.store.loadImportDataSetTypes();
    this.importDataSetLoading$ = this.store.Listen(s => s.loading);
    this._subscriptions.push(this.store.Listen(s => s.columns).subscribe(importDataSetColumns => {
      this._dataSetColumns = importDataSetColumns;
    }));
    this._subscriptions.push(this.store.Listen(s => s.types).subscribe(importDataSetTypes => {
      if (importDataSetTypes == null) {
        return;
      }
      this.items = importDataSetTypes.map(ds => {
        const attributes = this._getCountAttributes(ds);
        const geometryType = this.translationStore.FindTranslationForSelectedLanguage(first(ds.GeometryType));
        return {
          Id: ds.Id,
          SourceItem: ds,
          Attributes: attributes,
          GeometryType: geometryType,
          Status: -1,
          StatusClass: 'ap-status-green',
          StatusDesc: 'Global__Active',
        };
      });
    }));
  }

  gridBuilder(): void {
    this.columns = [
      new ApDynGridStatusColumnConfig({
        field: 'Status',
        showHeaderTitle: true,
        class: 'StatusClass',
        description: 'StatusDesc'
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.DataSetName',
        title: 'Global__Name',
        filterable: true,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.FileType',
        title: 'Global__File_Type',
        filterable: true,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'GeometryType',
        title: 'Global__Geometry',
        filterable: true,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Attributes',
        title: 'Global__Attributes',
        filterable: true,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridEditColumnConfig({
        disabled: true
      })
    ];
    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardSection()
    );
  }

  private _getCountAttributes(item: IDataSetType): number {
    let count = 0;
    const findDataSetColumns = this._dataSetColumns.filter(dsc => dsc.DataSetType.Id === item.Id);
    if (findDataSetColumns) {
      count = findDataSetColumns.length;
    }
    return count;
  }
}
